"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupHelper = void 0;
var lodash_1 = __importDefault(require("lodash"));
var groups_1 = require("../data/groups");
var group_types_1 = require("../types/group.types");
var lead_types_1 = require("../types/lead.types");
var GroupHelper = /** @class */ (function () {
    function GroupHelper() {
        this._findGroupByState = function (platformGroups, stateCode) {
            var group = platformGroups.find(function (groupItem) { return groupItem.stateCode === stateCode; });
            if (!platformGroups) {
                return false;
            }
            return group;
        };
        this._findLinkFromGroup = function (platform, group, professionalArea) {
            if (professionalArea === group_types_1.NicheGroupType.OUTR ||
                professionalArea === group_types_1.NicheGroupType.SELECIONE ||
                platform === lead_types_1.PlatformType.Telegram // TELEGRAM USERS WILL ONLY BE REDIRECTED TO GENERAL GROUPS!
            ) {
                // send to global groups
                var activeMainGroups = group === null || group === void 0 ? void 0 : group.mainGroups.filter(function (groupItem) { return groupItem.status === true; });
                var link = lodash_1.default.shuffle(activeMainGroups)[0].url;
                return link;
            }
            // else, lets shuffle some niche groups and get a target link
            // this is a whatsapp only feature
            var activeNicheGroups = group === null || group === void 0 ? void 0 : group.nicheGroups.filter(function (nicheGroup) { return nicheGroup.status === true; });
            var targetedNicheGroups = activeNicheGroups === null || activeNicheGroups === void 0 ? void 0 : activeNicheGroups.filter(function (tng) { return tng.nicheGroupKey === professionalArea; });
            var targetedNicheGroupLink = lodash_1.default.shuffle(targetedNicheGroups)[0].url;
            return targetedNicheGroupLink;
        };
    }
    GroupHelper.prototype.getGroupLink = function (platform, stateCode, professionalArea) {
        var link = "";
        switch (platform) {
            case lead_types_1.PlatformType.Telegram:
                var telegramStateGroup = this._findGroupByState(groups_1.TelegramGroups, stateCode);
                if (!telegramStateGroup) {
                    return false;
                }
                link = this._findLinkFromGroup(platform, telegramStateGroup, professionalArea);
                return link;
            case lead_types_1.PlatformType.WhatsApp:
            default:
                var whatsAppStateGroup = this._findGroupByState(groups_1.WhatsAppGroups, stateCode);
                if (!whatsAppStateGroup) {
                    return false;
                }
                link = this._findLinkFromGroup(platform, whatsAppStateGroup, professionalArea);
                return link;
        }
    };
    return GroupHelper;
}());
exports.GroupHelper = GroupHelper;
//# sourceMappingURL=GroupHelper.js.map